export const documentHasAttachment = (attachment_ids: number[]): boolean => {
  return attachment_ids.length > 0
}
